import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=3f547e56&scoped=true&"
import script from "./RatingQuestion.vue?vue&type=script&lang=js&"
export * from "./RatingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RatingQuestion.vue?vue&type=style&index=0&id=3f547e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f547e56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VSlider})
